/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".accept-decline-dialog-container[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:16px;margin:0}.accept-decline-dialog-container[_ngcontent-%COMP%]   .button-container[_ngcontent-%COMP%]{padding:8px 0}.accept-decline-dialog-container[_ngcontent-%COMP%]   .mat-raised-button.mat-primary[_ngcontent-%COMP%]{color:#fff!important}"];
export { styles as styles };
